import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor(private toastr: ToastrService) { }
  htmlSuccess(message: string) {
    this.toastr.clear();
    this.toastr.success(message, '', {
      positionClass: 'toast-top-center',
      enableHtml: true,
      timeOut: 3000,
      toastClass: 'ngx-toastr' // Apply the custom CSS class here
    });
  }
  
  htmlError(message: string) {
    this.toastr.clear();
    this.toastr.error(message, '', {
      positionClass: 'toast-top-center',
      enableHtml: true,
      timeOut: 3000,
      // toastClass: 'ngx-toastr' // Apply the custom CSS class here
    });
  }

  htmlWarning(message: string) {
    this.toastr.clear();
    this.toastr.warning(message, '', {
      positionClass: 'toast-top-center',
      enableHtml: true,
      timeOut: 3000,
      toastClass: 'ngx-toastr' // Apply the custom CSS class here
    });
  }

  htmlInfo(message: string) {
    this.toastr.clear();
    this.toastr.info(message, '', {
      positionClass: 'toast-top-center',
      enableHtml: true,
      timeOut: 3000,
      toastClass: 'ngx-toastr' // Apply the custom CSS class here
    });
  }
}
